module.exports = __webpack_public_path__ + "static/img/img09.01b6c3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/73/img09.jpg
// module id = G41K
// module chunks = 1